module.exports = __webpack_public_path__ + "static/media/phone_icon.d99e1182.svg";